import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { ICompanyMast } from "../../models/CompanyMast";
import { baseUrl, Fetch, ILazyParams } from "../../shared/Fetch";
import { EmptyCompany } from "./EmptyCompany";
import { IModel } from "./CompanyMast";
import { Search } from "../../shared/Search";
import { ILogin, IPermissionProps } from "../../models/Login";
import { CompanyAuthorizedSignatory } from "./CompanyAuthorizedSignatory";
import { Certificate } from "crypto";
import { CompanyDocumentUpload } from "./CompanyDocument";
import { CompanyDocumentMail } from "./CompanyDocumentMail";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}

export interface IModel2 {
    open: boolean,
    singleData: any,
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ICompanyMast>, loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'company_ID',
        sortOrder: -1
    });

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });


    const [modal2, setModal2] = useState({ singleData: {}, open: false } as IModel2);
    const [modal3, setModal3] = useState({ singleData: {}, open: false } as IModel2);
    const [modal4, setModal4] = useState({ singleData: {}, open: false } as IModel2);

    const hideDialog2 = () => {
        setModal2({ singleData: {}, open: false });
        setModal3({ singleData: {}, open: false });
        setModal4({ singleData: {}, open: false });


    };

    useEffect(() => {
        getTableDataCount();
        loadTableData();
    }, [globalFilter, lazyParams, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const getTableDataCount = async () => {
        const response = await Fetch("Company_Mast/count", "GET", null, `filter=${globalFilter}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Company_Mast", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<ICompanyMast> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyCompany });
    };


    const openEdit = (rowDatauser: ICompanyMast) => {
        rowDatauser.city = {
            city_ID: rowDatauser.company_City,
            city_Name: rowDatauser.city_Name
        }
        rowDatauser.state = {
            state_ID: rowDatauser.company_State,
            state_Name: rowDatauser.state_Name
        }
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    {(_roles.includes(1)) && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />}
                </div>
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Company</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const actionBodyTemplate = (rowData: ICompanyMast) => {
        return (
            <div className="actions">
                {(_roles.includes(1) || _roles.includes(16)) && <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />}
                {(_roles.includes(1) || _roles.includes(16)) && <Button icon="pi pi-plus" className="p-button-rounded  p-button-text ml-2" onClick={() => AddAuthorizedSignatory(rowData)} tooltip="Signatory" />}
                {(_roles.includes(1) || _roles.includes(16)) && <Button icon="pi pi-upload" className="p-button-rounded  p-button-text ml-2" onClick={() => AddCompanyDocument(rowData)} tooltip="Upload Document" />}
                <Button icon="pi pi-envelope" className="p-button-rounded  p-button-text ml-2" onClick={() => openSendComapnyDetails(rowData)} tooltip="Send Mail" />
                {rowData.company_Logo != null && <Button icon="pi pi-arrow-down" className="p-button-rounded  p-button-text ml-2" onClick={() => companyLogoDownload(rowData)} tooltip="Company Logo" />}
            </div>
        );
    };

    const AddAuthorizedSignatory = (rowData: ICompanyMast) => {
        setModal2({ open: true, singleData: rowData });
    }

    const AddCompanyDocument = (rowData: ICompanyMast) => {
        setModal3({ open: true, singleData: rowData });
    }
    const openSendComapnyDetails = (rowData: any) => {
        setModal4({ open: true, singleData: rowData });

    }

    const companyLogoDownload = async (rowData: ICompanyMast) => {
        const Id = rowData.company_ID;
        const params = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token
                    }`
            },
        };
        try {
            const response = await fetch(`${baseUrl}Company_Mast/downloadCompanyLogo?comp_Id=${Id}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${rowData.company_Name}Logo.png`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went wrong', life: 3000 });
        }
    };

    const updateCompany = async (rowData: ICompanyMast) => {
        const formData = new FormData();
        formData.append("data", JSON.stringify(rowData));


        const response = await fetch(`${baseUrl}Company_Mast`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token
                    }`
            },
            body: formData,
        });

        if (response.ok) {
            props.toast.current.show({ severity: "success", detail: "Company Updated Successfully", life: 3000 });
            loadTableData();
        } else {
            console.error("Error submitting data:", response.statusText);
        }
    };

    const acptFunc = (data: ICompanyMast) => {
        const newData: ICompanyMast = { ...data, invoice_Process: (data.invoice_Process === 1 || data.invoice_Process === null) ? 2 : 1 };
        updateCompany(newData);
    }
    const rejectFunc = () => {
        // dialog closed.
    }

    const refactorInvoiceProcess = (rowData: ICompanyMast) => {
        confirmDialog({
            message: `Are you sure you want to change Invoice Process to ${(rowData.invoice_Process === 1 || rowData.invoice_Process === null) ? "Quick Book" : "System Generted"}?`,
            // header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-success',
            accept: () => acptFunc(rowData),
            reject: () => rejectFunc()
        });
    }



    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small"
                value={tableData.tableData} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Company found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column field="company_Name" header="Company Name" sortable />
                <Column field="feid" header="FEID" sortable />
                <Column field="company_Address" header="Address" />
                <Column field="state_Name" header="State" sortable />
                <Column field="city_Name" header="City" sortable />

                <Column field="company_Zip" header="Zip Code" sortable />
                {<Column header="Action" body={actionBodyTemplate} />}
                <Column field="invoice_Process" header="Invoice Process" body={(rowData) => <Button className="bg-white border-none text-blue-600 underline" label={(rowData.invoice_Process === 1 || rowData.invoice_Process === null) ? "System Generted" : "Quick Book"} tooltip="Inovice Process" onClick={() => refactorInvoiceProcess(rowData)}></Button>} />
                <Column field="group_Name" header="Group Name" sortable />
            </DataTable>

            <CompanyDocumentUpload singleData={modal3.singleData} open={modal3.open} hideDialog={hideDialog2} toast={props.toast} />
            <CompanyDocumentMail singleData={modal4.singleData} open={modal4.open} hideDialog={hideDialog2} toast={props.toast} />
            <CompanyAuthorizedSignatory singleData={modal2.singleData} open={modal2.open} hideDialog={hideDialog2} toast={props.toast}></CompanyAuthorizedSignatory>
            <ConfirmDialog />
        </>
    );
}
